// src/pages/NotFound.js
import React from 'react';
import { Typography, Container } from '@mui/material';

const NotFound = () => {
  return (
    <Container style={{ textAlign: 'center', paddingTop: '50px' }}>
      <Typography variant="h3" color="error" gutterBottom>
        404 - Page Not Found
      </Typography>
      <Typography variant="body1">
        Sorry, the page you are looking for does not exist.
      </Typography>
    </Container>
  );
};

export default NotFound;
